import {BootstrapBreakpoint, bootstrapBreakpointByName} from "../../../common/resolutionConstants";
import {Resolution} from "../../../common/resolution";
import {autoRegister, resolve} from "../../../container";
import type {Nullable} from "../../../bootstrap/common/types";

export class DialogActivation {
    private activationBreakpoint: Nullable<BootstrapBreakpoint>;
    private active: boolean;

    public constructor(
        private anchorElement: HTMLElement,
        private dialogContent: HTMLElement,
        activationBreakpointName: string,
        private resolution: Resolution
    ) {
        this.activationBreakpoint = bootstrapBreakpointByName(activationBreakpointName);
        this.activate(!this.activationBreakpoint || this.resolution.downTo(this.activationBreakpoint));
        if (this.activationBreakpoint) {
            this.resolution.onBootstrapBreakpointChange(breakpoint => {
                this.activate(breakpoint.isDownTo(this.activationBreakpoint!));
            });
        }
    }

    public ifActive(callback: () => void): void {
        if (this.active) {
            callback();
        }
    }

    private activate(value: boolean): void {
        this.active = value;
        if (this.active) {
            this.anchorElement.classList.remove("inactive");
            this.dialogContent.classList.remove("inactive");
        } else {
            this.anchorElement.classList.add("inactive");
            this.dialogContent.classList.add("inactive");
        }
    }
}

@autoRegister()
export class DialogActivationFactory {
    public constructor(
        private resolution: Resolution = resolve(Resolution)
    ) {
    }

    public create(anchorElement: HTMLElement, dialogContent: HTMLElement, activationBreakpointName: string): DialogActivation {
        return new DialogActivation(anchorElement, dialogContent, activationBreakpointName, this.resolution);
    }
}
